import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { Trans, useTranslation } from "react-i18next";

export default function AboutPage() {
  const { t } = useTranslation();
  return (
    <div data-testid="about-page" className="px-6 md:px-10 lg:px-16 py-16 md:py-24 max-w-4xl">
      <div className="overline mb-3">{t("about.breadcrumb")}</div>
      <h1 className="font-display font-black text-5xl md:text-7xl tracking-[-0.04em] leading-[.95] mb-10">
        {t("about.heroLine1")}<br /><span className="italic font-medium text-blue-700">{t("about.heroLine2")}</span>
      </h1>

      <div className="space-y-10 text-zinc-700 leading-relaxed text-lg max-w-3xl">
        <p>
          <Trans i18nKey="about.intro1" components={{ strong: <strong /> }} />
        </p>

        <p>
          <Trans i18nKey="about.intro2" components={{ strong: <strong /> }} />
        </p>

        <section className="border-t border-zinc-200 pt-8">
          <div className="overline mb-3">{t("about.catalogToday")}</div>
          <ul className="grid sm:grid-cols-3 gap-px bg-zinc-200 border border-zinc-200 not-prose">
            <Stat n="150+" l={t("about.stat1Label")} />
            <Stat n="85+" l={t("about.stat2Label")} />
            <Stat n="24+" l={t("about.stat3Label")} />
          </ul>
        </section>

        <section>
          <div className="overline mb-3">{t("about.whatsInside")}</div>
          <ul className="space-y-2 list-disc ps-5">
            <li><Trans i18nKey="about.li1" components={{ em: <em /> }} /></li>
            <li><Trans i18nKey="about.li2" components={{ em: <em /> }} /></li>
            <li><Trans i18nKey="about.li3" components={{ em: <em /> }} /></li>
            <li><Trans i18nKey="about.li4" components={{ em: <em /> }} /></li>
          </ul>
        </section>

        <section>
          <div className="overline mb-3">{t("about.aiBuiltIn")}</div>
          <p>
            <Trans i18nKey="about.aiBody" components={{ strong: <strong />, em: <em /> }} />
          </p>
        </section>

        <section className="border-t border-zinc-200 pt-8">
          <div className="overline mb-3">{t("about.getStarted")}</div>
          <div className="flex flex-wrap gap-3">
            <Link to="/conferences" data-testid="about-cta-browse" className="btn-primary">{t("about.ctaBrowse")} <ArrowUpRight size={16} data-arrow="forward" /></Link>
            <Link to="/register" data-testid="about-cta-register" className="btn-secondary">{t("about.ctaRegister")}</Link>
            <a href="/api/feed.xml" target="_blank" rel="noreferrer" className="btn-secondary">{t("about.ctaRss")}</a>
          </div>
        </section>

        <section className="border-t border-zinc-200 pt-8 text-sm text-zinc-500 font-mono">
          {t("about.contact")} · <a href="mailto:hello@conferencely.org" className="underline">hello@conferencely.org</a><br />
          © {new Date().getFullYear()} Symposia · <Link to="/terms" className="underline">{t("footer.terms")}</Link> · <Link to="/privacy" className="underline">{t("footer.privacy")}</Link>
        </section>
      </div>
    </div>
  );
}

function Stat({ n, l }) {
  return (
    <li className="bg-white p-5 not-prose list-none">
      <div className="font-display font-black text-4xl tracking-tight tabular">{n}</div>
      <div className="overline mt-1">{l}</div>
    </li>
  );
}
